export default "__VITE_ASSET__B333lGs5__"